import { useDelivery } from '~/src/common/hooks/useDelivery';
import { useNiceModal } from '~/src/common/services/ModalsManager/utils';

/**
 * Dans certains cas on souhaite intercepter si nous avons les informations de livraisons
 * Pour qu'une livraison soit valide il nous faut une adresse valide et un slot
 * @returns { isValid: si les infos sont valides, intercept: fonction qui montre les modales de renseignement et renvoie une promesse sur leur completion }
 */
export const useRequireDelivery = () => {
  const deliveryAddressModal = useNiceModal('delivery-address-modal');
  const deliverySelectSlotModal = useNiceModal('delivery-select-slot-modal');

  const delivery = useDelivery();

  const intercept = () => {
    if (delivery.address == null)
      return { type: 'address' as const, promise: deliveryAddressModal.show() };
    if (!delivery.isTimeSlotValid)
      return { type: 'slot' as const, promise: deliverySelectSlotModal.show() };
  };

  return { isValid: delivery.address != null && delivery.isTimeSlotValid, intercept };
};
